
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { DataTransfer_SetInfo_$reflection } from "../Shared/Set.js";
import { RequestedValue$1, RequestedValue$1_$reflection } from "../Shared/Shared.js";
import { union_type, class_type, record_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { getSetInfo } from "../Requests/Set.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { toLocalTime, toString } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { WarningAlert } from "../Components/Alert.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ofArray, map, isEmpty } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";

class State extends Record {
    constructor(SetInfo) {
        super();
        this.SetInfo = SetInfo;
    }
}

function State_$reflection() {
    return record_type("Widgets.SetInfoWidget.State", [], State, () => [["SetInfo", RequestedValue$1_$reflection(DataTransfer_SetInfo_$reflection())]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetInfoFetched", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Widgets.SetInfoWidget.Msg", [], Msg, () => [[["Item", DataTransfer_SetInfo_$reflection()]], [["Item", class_type("System.Exception")]]]);
}

function update(msg, state) {
    if (msg.tag === 1) {
        return [state, Cmd_none()];
    }
    else {
        return [new State(new RequestedValue$1(1, [msg.fields[0]])), Cmd_none()];
    }
}

function init(setId) {
    return [new State(new RequestedValue$1(0, [])), getSetInfo(setId, (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(1, [Item_1])))];
}

function InfoContent(props) {
    let elems;
    const patternInput = useTranslation();
    let reservationAlert;
    const matchValue = props.SetInfo.CurrentReservation;
    if (matchValue != null) {
        const reservation = matchValue;
        const startDate = toString(toLocalTime(reservation.StartDate), "dd.MM.yyyy");
        const endDate = toString(toLocalTime(reservation.EndDate), "dd.MM.yyyy");
        reservationAlert = createElement(WarningAlert, {
            Label: `${patternInput[0]("tool.reserved_for")} ${reservation.ReceiverName} ${startDate} - ${endDate}`,
        });
    }
    else {
        reservationAlert = defaultOf();
    }
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex-col", "flex", "gap-4"])], (elems = toList(delay(() => append(props.DisplayReservationAlert ? singleton(reservationAlert) : empty(), delay(() => (isEmpty(props.SetInfo.ActiveProblemReports) ? singleton(defaultOf()) : map((problemReport) => {
        let arg_1;
        return createElement(WarningAlert, {
            Label: (arg_1 = {
                timestamp: toString(toLocalTime(problemReport.Timestamp), "dd.MM.yyyy"),
                toolName: problemReport.ToolName,
            }, patternInput[1].t("set_info.problem_report_exists", arg_1)),
        });
    }, props.SetInfo.ActiveProblemReports)))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function SetInfo(props) {
    const matchValue = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init, update, (_arg, _arg_1) => {
    }), props.SetId, undefined)[0].SetInfo;
    if (matchValue.tag === 0) {
        return defaultOf();
    }
    else {
        return createElement(InfoContent, {
            DisplayReservationAlert: props.DisplayReservationAlert,
            SetInfo: matchValue.fields[0],
        });
    }
}

